/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ApiError } from '../model/apiError';
import { ProgramacionActividad } from '../model/programacionActividad';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class KoguiProgramacionActividadService {

    protected basePath = 'https://virtserver.swaggerhub.com/yohanyflores/kogui/1.0.0';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    /**
     * La lista de programaciones para una actividad especifica.
     * Las Actividades.
     * @param actividadId El id de una actividad asociado a la empresa.
     * @param xFcmtoken 
     * @param $fields 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiActividadByIdProgamaciones(actividadId: string, xFcmtoken?: string, $fields?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ProgramacionActividad>>;
    public getKoguiActividadByIdProgamaciones(actividadId: string, xFcmtoken?: string, $fields?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProgramacionActividad>>>;
    public getKoguiActividadByIdProgamaciones(actividadId: string, xFcmtoken?: string, $fields?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProgramacionActividad>>>;
    public getKoguiActividadByIdProgamaciones(actividadId: string, xFcmtoken?: string, $fields?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (actividadId === null || actividadId === undefined) {
            throw new Error('Required parameter actividadId was null or undefined when calling getKoguiActividadByIdProgamaciones.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<ProgramacionActividad>>(`${this.configuration.basePath}/kogui/actividades/${encodeURIComponent(String(actividadId))}/programaciones/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
